import { Component, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Notification } from '../notification/notification';

@Component({
  selector: 'ui-notification-success',
  imports: [NgIcon, Notification],
  templateUrl: './notification-success.html',
})
export class NotificationSuccess {
  uuid = input.required<string>();
  duration = input.required<number>();
  title = input.required<string>();
  subtitle = input<string>('');
}
